// 导入封装好的 axios 实例
import request from '@/utils/request'


//告警列表接口
export function alarmList(data) {
    return request({
        url: '/program/alarm/details/page',
        method: 'post',
        data
    })
}

//根据传感器确认告警
export function confirmSensor(id) {
    return request({
        url: `/program/alarm/details/confirm/sensor?id=${id}`,
        method: 'post',
    })
}


//一键确认告警
export function confirmAll() {
    return request({
        url: '/program/alarm/details/confirm/all',
        method: 'post',
    })
}